import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/next/font/google/target.css?{\"path\":\"src/app/business/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/business/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/client/src/components/ui/toaster.tsx");
